export const dateFormat: string = "yyyy-MM-dd'T'HH:mm:ss.SSSZZ";
export const dateFormatIcal: string = "yyyyMMdd'T'HHmmss'Z'";

//wednesday 20 march à 12:00
export const dateFormatWeekdayTime: string = "cccc d LLLL à T";

//wednesday 20 march
export const dateFormatWeekday: string = "cccc d LLLL";

export const timeFormat: string = "HH':'mm";
